/* Sunkissed (Nov 1 2026): product page "Complete the set" card, design A (Ben picked A).
   Card reads left to right: label on top, photo + name, colour and price, then the matching piece's
   sizes and one button "Add bottoms in S". Builds on the theme's complementary card (.complementary-products .product-upsell).
   Nov 3 2026 (site review): the Escape key now closes the Find my size window, like its close button. */
(function () {
  'use strict';
  function money(c) { return window.SK_INTL ? SK_INTL.money(c) : ('$' + (c / 100).toFixed(2)).replace('.00', ''); }
  function enhance(card) {
    if (card.getAttribute('data-sk-a')) return; card.setAttribute('data-sk-a', '1');
    var link = card.querySelector('a.product-upsell__link, a.product-upsell__image__link'); if (!link) return;
    var url = link.getAttribute('href').split('?')[0];
    fetch(url + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return;
      /* Nov 1 2026 fix: the $9 set saving only applies to a matching top + bottom. Anything else (sarong, dress) is "Pairs well with", no saving promised */
      var cur = (document.querySelector('meta[property="og:title"]') || {}).content || document.title || '';
      var curIsPiece = /\b(top|bottoms?)\b/i.test(cur) && !/\bset\b/i.test(cur);
      var addIsPiece = /\b(top|bottoms?)\b/i.test(p.title) && !/\bset\b/i.test(p.title);
      var isSet = curIsPiece && addIsPiece;
      var short = (p.title.split(' - ')[0] || '').replace(/^(Le|La)\s+/i, '').replace(/\s*Bikini\s*/i, ' ').replace(/\s*Swimsuit/i, '').trim();
      var piece = /bottom/i.test(p.title) ? 'bottoms' : /top/i.test(p.title) ? 'top' : (/sarong/i.test(p.title) ? 'sarong' : /dress/i.test(p.title) ? 'dress' : /towel/i.test(p.title) ? 'towel' : short.toLowerCase() || 'this');
      var one = p.variants.length === 1 || p.variants.every(function (v) { return /^(os|one size|default title)$/i.test(v.title); });
      var price = card.querySelector('.product-upsell__price'); if (price) price.innerHTML = money(p.price) + (isSet ? ' <span class="sk-a-save">· save $9 as a set</span>' : '');
      var lab = card.querySelector('.sk-set-label'); if (lab) { card.insertBefore(lab, card.firstChild); lab.textContent = isSet ? 'Complete the set · save $9' : 'Pairs well with'; }
      var wrap = document.createElement('div'); wrap.className = 'sk-a-pick';
      var sel = null, busy = false;
      if (one) {
        var ov = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        sel = ov && ov.available ? String(ov.id) : null;
        wrap.innerHTML = '<button type="button" class="sk-a-add"' + (sel ? '' : ' disabled') + '>' + (sel ? 'Add the ' + piece + ' · ' + money(p.price) : 'Sold out') + '</button>';
      } else {
        wrap.innerHTML = '<div class="sk-a-sizes">' + p.variants.map(function (v) {
          return '<button type="button" data-v="' + v.id + '"' + (v.available ? '' : ' disabled') + ' aria-pressed="false">' + v.title + '</button>';
        }).join('') + '</div><button type="button" class="sk-a-add">Pick a size for the ' + piece + '</button>';
      }
      card.appendChild(wrap);
      var btn = wrap.querySelector('.sk-a-add');
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-v]');
        if (b) { sel = b.getAttribute('data-v'); wrap.querySelectorAll('[data-v]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); btn.textContent = 'Add ' + piece + ' in ' + b.textContent; return; }
        if (e.target !== btn) return;
        if (!sel) { wrap.classList.add('sk-a-nudge'); setTimeout(function () { wrap.classList.remove('sk-a-nudge'); }, 900); return; }
        if (busy) return; busy = true; var t = btn.textContent; btn.textContent = 'Adding...';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +sel, quantity: 1 }] }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            busy = false;
            if (res.ok) { btn.textContent = 'Added'; document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); var c = document.querySelector('[data-cart-toggle]'); if (c) c.click(); setTimeout(function () { btn.textContent = t; }, 2500); }
            else btn.textContent = (res.j && res.j.description) || 'Sold out';
          }).catch(function () { busy = false; btn.textContent = 'Try again'; });
      });
      card.classList.add('sk-a');
    });
  }
  function scan() { document.querySelectorAll('main .complementary-products .product-upsell').forEach(function (c) { if (c.querySelector('.sk-set-label')) enhance(c); }); }
  new MutationObserver(function () { clearTimeout(scan.t); scan.t = setTimeout(scan, 200); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
})();
/* Nov 1 2026: desktop colour swatches fill the whole row, then "+N" for the rest (phones keep 7 + "+N"). */
(function () {
  'use strict';
  function fit() {
    document.querySelectorAll('[data-sk-colours]').forEach(function (w) {
      var row = w.querySelector('[data-sk-colour-row]'); if (!row) return;
      var items = Array.prototype.slice.call(row.querySelectorAll('.sk-colours__a'));
      var more = row.querySelector('[data-sk-colours-more]');
      if (!w.hasAttribute('data-sk-lim')) w.setAttribute('data-sk-lim', items.filter(function (a) { return !a.classList.contains('sk-colours__a--x'); }).length);
      var lim = +w.getAttribute('data-sk-lim');
      if (window.innerWidth >= 990 && items.length > 1) {
        var cs = getComputedStyle(row), gap = parseFloat(cs.columnGap || cs.gap) || 8;
        var sw = items[0].getBoundingClientRect().width; if (!sw) return;
        var slots = Math.floor((row.clientWidth + gap) / (sw + gap));
        lim = items.length <= slots ? items.length : Math.max(1, slots - 1);
      }
      var cur = items.findIndex(function (a) { return a.hasAttribute('aria-current'); });
      if (cur >= lim && lim > 1) {
        /* keep the chosen colour in view: it takes the last visible slot (phones too).
           Nov 1 2026: phones used to open the full list for this, and the address bar resizing on scroll re-opened it after "Show less" */
        items.forEach(function (a, i) { a.classList.toggle('sk-colours__a--x', !(i < lim - 1 || i === cur)); });
      } else {
        items.forEach(function (a, i) { a.classList.toggle('sk-colours__a--x', i >= lim); });
      }
      if (more) {
        var n = items.length - lim;
        more.style.display = n > 0 ? '' : 'none';
        more.setAttribute('data-more', '+' + n);
        if (!w.classList.contains('sk-colours--all')) more.textContent = '+' + n;
      }
    });
  }
  var t, lastW = window.innerWidth; window.addEventListener('resize', function () { if (window.innerWidth === lastW) return; lastW = window.innerWidth; clearTimeout(t); t = setTimeout(fit, 150); });
  if (document.readyState !== 'loading') fit(); else document.addEventListener('DOMContentLoaded', fit);
  window.addEventListener('load', fit);
})();

/* Nov 1 2026: after picking a colour the page keeps its scroll position and the open/closed swatch list, so nothing jumps */
(function () {
  'use strict';
  var K = 'sk_sw_keep';
  try {
    var k = JSON.parse(sessionStorage.getItem(K) || 'null');
    if (k && Date.now() - k.t < 15000) {
      sessionStorage.removeItem(K);
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      var go = function () {
        window.scrollTo(0, k.y);
        if (k.all) { var w = document.querySelector('[data-sk-colours]'); var m = w && w.querySelector('[data-sk-colours-more]'); if (w && m && !w.classList.contains('sk-colours--all')) m.click(); }
      };
      if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
      /* the theme can jump back to the top while it loads, so hold the position for a moment unless the shopper scrolls */
      var stop = false, n = 0;
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, function () { stop = true; }, { once: true, passive: true }); });
      var hold = setInterval(function () { if (stop || ++n > 25) { clearInterval(hold); return; } if (Math.abs(window.scrollY - k.y) > 4) window.scrollTo(0, k.y); }, 80);
    }
  } catch (e) {}
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sk-colours] .sk-colours__a');
    if (!a || a.hasAttribute('aria-current')) return;
    var w = a.closest('[data-sk-colours]');
    try { sessionStorage.setItem(K, JSON.stringify({ y: window.scrollY, all: w.classList.contains('sk-colours--all'), t: Date.now() })); } catch (err) {}
  }, true);
})();

/* Nov 1 2026 (Ben, upgrade 2): "Find my size" in 2 questions, from the approved chart (the same one as the Size guide accordion),
   and the Size guide shows only the tables that match this product. */
(function () {
  'use strict';
  var page = document.querySelector('.product__page'); if (!page) return;
  var title = ((document.querySelector('meta[property="og:title"]') || {}).content || document.title || '').toLowerCase();
  var kind = /one[- ]piece|swimsuit/.test(title) ? 'one' : /\bset\b/.test(title) ? 'set' : /\btop\b/.test(title) ? 'top' : /\bbottoms?\b/.test(title) ? 'bottom' : 'other';
  var SIZES = ['XS', 'S', 'M', 'L', 'XL'];
  var BUST = ['31-32.5"', '32.5-34.5"', '34.5-36.5"', '36.5-38.5"', '38.5-40.5"'];
  var BUSTCM = ['79-83', '83-88', '88-93', '93-98', '98-103'];
  var HIPS = ['33-35"', '35-37"', '37-39.5"', '39.5-41.5"', '41.5-43.5"'];
  var HIPSCM = ['84-89', '89-94', '94-100', '100-105', '105-110'];
  function fieldsets() { return Array.prototype.filter.call(page.querySelectorAll('.radio__fieldset:not(.radio__fieldset--swatches)'), function (f) { return f.offsetParent !== null && f.querySelector('input[type="radio"]'); }); }
  function pick(fs, val) { if (!fs) return; var r = Array.prototype.find.call(fs.querySelectorAll('input[type="radio"]'), function (i) { return i.value === val; }); if (r && !r.disabled) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); var l = r.closest('label') || page.querySelector('label[for="' + r.id + '"]'); if (l) l.click(); } }

  /* Size guide: show only the matching tables */
  function trimGuide() {
    page.querySelectorAll('details.sk-acc').forEach(function (d) {
      if (!d.querySelector('.sk-sz') || d.dataset.skTrim) return; d.dataset.skTrim = '1';
      if (kind === 'other') { d.hidden = true; return; }
      var want = kind === 'set' ? ['tops', 'bottoms'] : kind === 'top' ? ['tops'] : kind === 'bottom' ? ['bottoms'] : ['one-pieces'];
      d.querySelectorAll('.sk-sz__h').forEach(function (h) {
        var show = want.indexOf(h.textContent.trim().toLowerCase()) > -1, t = h.nextElementSibling;
        h.hidden = !show; if (t && t.tagName === 'TABLE') t.hidden = !show;
      });
      if (kind !== 'one') d.querySelectorAll('.sk-sz__note').forEach(function (n) { if (/torso/i.test(n.textContent)) n.hidden = true; });
    });
  }

  /* Find my size */
  var modal = null, ans = {};
  function build() {
    var qs = [];
    if (kind !== 'bottom') qs.push({ k: 'b', t: 'Your bust', o: BUST, cm: BUSTCM });
    if (kind !== 'top') qs.push({ k: 'h', t: 'Your hips', o: HIPS, cm: HIPSCM });
    modal = document.createElement('div'); modal.className = 'sk-fit-modal'; modal.hidden = true;
    modal.innerHTML = '<div class="sk-fit-modal__bg" data-fit-close></div><div class="sk-fit-modal__panel" role="dialog" aria-label="Find my size"><button type="button" class="sk-fit-modal__x" data-fit-close aria-label="Close">&#10005;</button>' +
      '<p class="sk-fit-modal__lbl">Find my size</p><h3 class="sk-fit-modal__h">' + qs.length + ' quick question' + (qs.length > 1 ? 's' : '') + '</h3>' +
      qs.map(function (q) { return '<div class="sk-fit-q"><p class="sk-fit-q__t">' + q.t + ', measured at the fullest part</p><div class="sk-fit-q__o">' + q.o.map(function (o, i) { return '<button type="button" data-fit-k="' + q.k + '" data-fit-i="' + i + '">' + o + '<small>' + q.cm[i] + ' cm</small></button>'; }).join('') + '</div></div>'; }).join('') +
      '<div class="sk-fit-res" data-fit-res hidden></div><p class="sk-fit-modal__note">Between two? Size up. Our suits are cut close to the body.</p></div>';
    document.body.appendChild(modal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });
    modal.addEventListener('click', function (e) {
      var t = e.target.closest('[data-fit-close]'); if (t) { close(); return; }
      var o = e.target.closest('[data-fit-k]');
      if (o) { ans[o.getAttribute('data-fit-k')] = +o.getAttribute('data-fit-i'); modal.querySelectorAll('[data-fit-k="' + o.getAttribute('data-fit-k') + '"]').forEach(function (x) { x.classList.toggle('is-on', x === o); }); result(); return; }
      if (e.target.closest('[data-fit-apply]')) { apply(); close(); }
    });
    return qs.length;
  }
  function rec() {
    var top = ans.b != null ? SIZES[ans.b] : null, bot = ans.h != null ? SIZES[ans.h] : null;
    if (kind === 'one') { if (ans.b == null || ans.h == null) return null; return { one: SIZES[Math.max(ans.b, ans.h)] }; }
    if (kind === 'set') { if (!top || !bot) return null; return { top: top, bot: bot }; }
    if (kind === 'top') return top ? { top: top } : null;
    if (kind === 'bottom') return bot ? { bot: bot } : null;
    return null;
  }
  function result() {
    var r = rec(), box = modal.querySelector('[data-fit-res]'); if (!r) { box.hidden = true; return; }
    var txt = r.one ? 'Your size: <b>' + r.one + '</b>' : (r.top ? 'Top <b>' + r.top + '</b>' : '') + (r.top && r.bot ? ' · ' : '') + (r.bot ? 'Bottom <b>' + r.bot + '</b>' : '');
    box.innerHTML = '<p class="sk-fit-res__t">' + txt + '</p><button type="button" class="btn btn--primary btn--solid sk-fit-res__go" data-fit-apply>Select ' + (r.one || (r.top && r.bot) ? 'my size' + (r.top && r.bot ? 's' : '') : 'my size') + '</button>';
    box.hidden = false;
  }
  function apply() {
    var r = rec(); if (!r) return; var fs = fieldsets();
    if (kind === 'set') { fs.forEach(function (f) { var l = ((f.querySelector('legend') || {}).textContent || '').toLowerCase(); if (/top/.test(l)) pick(f, r.top); else if (/bottom/.test(l)) pick(f, r.bot); }); }
    else pick(fs[0], r.one || r.top || r.bot);
  }
  function open() { if (!modal) build(); modal.hidden = false; document.documentElement.classList.add('sk-fit-open'); }
  function close() { if (modal) modal.hidden = true; document.documentElement.classList.remove('sk-fit-open'); }
  function addLink() {
    if (kind === 'other') return true;
    var row = page.querySelector('.sk-fit-row'); if (!row) return false;
    if (row.querySelector('.sk-fit-find')) return true;
    var a = document.createElement('button'); a.type = 'button'; a.className = 'sk-fit-find'; a.textContent = 'Find my size';
    a.addEventListener('click', open);
    var g = row.querySelector('.sk-fit-guide'); row.insertBefore(a, g || null);
    return true;
  }
  var n = 0; (function wait() { trimGuide(); if (!addLink() && n++ < 40) setTimeout(wait, 250); })();
})();
